// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"723":"087fd9ea0456b1aa","2094":"5a27495451ed76fd","2724":"0bf29bc18d24cd42","2960":"47c4568892c4d841"}[chunkId] + ".css";
};